import { JobSkillModel } from '../ts/interfaces/models/JobSkillModel';
import { BaseService } from './baseService';

class JobSkillService extends BaseService<JobSkillModel> {
  controllerName = 'jobSkill';
}

export const jobSkillService = new JobSkillService();
